/*
* libraries
*/
import { Component, OnInit, Output, EventEmitter, Input, SimpleChanges } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { MessageService } from '../../services/message.service'
import { StoreService } from '../../services/store.service'
import { SecurityService } from '../../services/security.service'
import * as words from '../../services/language'
import { Subscription } from "rxjs";

@Component({
    selector: 'app-side-menu',
    templateUrl: './side-menu.component.html',
    styleUrls: ['./side-menu.component.scss'],
    standalone: false
})
export class SideMenuComponent implements OnInit {
    //
    @Output() sideNavMessage$: EventEmitter<object> = new EventEmitter()

    // show the icons instead of the full text?
    @Input() compact: boolean = false

    // save the language
    @Input() language: string = 'EN'

    // settings
    public displaySettings: boolean = true

    // set all words
    public words = words.language

    //
    public image = { corporateLogoURL: null, display: false }

    // A handle to navbar event messages so we can unsubscribe later.
    private navbarWatcher: Subscription | null = null

    constructor(private route: ActivatedRoute, private ms: MessageService, private router: Router, private store: StoreService, public security: SecurityService) { 
        this.navbarWatcher = this.ms.channelComponents$.subscribe(res => {
            if (res['message'] == 'reloadLogo') {
                this.image = {
                    corporateLogoURL: res['value']['corporateLogoURL'],
                    display: res['value']['displayLogoInternal']
                }
                this.store.userAccount['corporateLogo'] = res['value']
            }
        })
    }

    ngOnInit() {
        if (this.store && this.store.userAccount) {
            const user = this.store.userAccount

            // image
            this.image = { corporateLogoURL: null, display: false }
            if (user['corporateLogo'] && user['corporateLogo'].corporateLogoURL) {
                this.image = { corporateLogoURL: user['corporateLogo'].corporateLogoURL, display: (user['corporateLogo'].displayLogoInternal == 0) ? false : true }
            }
        }

        this.router.events.subscribe(() => {
            const path = this.route.snapshot.url[0].path
            const pattern = new RegExp('settings', 'i')
            const displayed = (path && pattern.test(path))

            const menu = document.querySelector('#collapseSettings') as HTMLElement
            if (!menu) {
                return
            }

            menu.classList.add('collapse')

            if (!displayed) {
                return
            }

            menu.classList.remove('collapse')
        })
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!changes) {
            return
        }

        if (changes.compact) {
            this.condense()
        }
    }

    ngOnDestroy() {
        if (!this.navbarWatcher) {
            return
        }

        this.navbarWatcher.unsubscribe()
    }

    protected condense = () => {
        const body = (document.querySelector('body') as HTMLBodyElement)

        if (this.compact) {
            body.dataset.leftbarCompactMode = 'condensed'
            body.dataset.forceCompact = 'true'
            return
        }

        body.dataset.leftbarCompactMode  = ''
        body.dataset.forceCompact = 'false'
    }

    protected active = (match: string): boolean => {
        if (!match) {
            return false
        }

        let path :string = ''
        for (const part of this.route.snapshot.url) {
            path += `${part.path} `
        }

        const pattern = new RegExp(`${match}`, 'i')
        return (path && pattern.test(path))
    }

    /**
     * If menu is in compact mode we don't want to allow clicks on collapsible menus
     * @param {Event} e 
     */
    protected checkCompact = (e: Event) => {
        const body = document.querySelector('body') as HTMLBodyElement
        if (!body || !body.dataset || !body.dataset.leftbarCompactMode) {
            return
        }

        if (body.dataset.leftbarCompactMode !== 'condensed') {
            return
        }

        e.stopPropagation()
        e.preventDefault()
    }
}
